import { rescue } from '@phoenix/helpers/common-helper';

export default {
  methods: {
    sendSearchClickTracking(term, url, position, category) {
      const searchEvent = this.getSearchClickTracking(term, url, position, category);
      if (searchEvent) {
        rescue(() => window.tracking.pushEvent(searchEvent));
      }
    },

    getSearchClickTracking(term, url, position, category) {
      if (!window.tracking?.getSearchClickResult) {
        return;
      }

      return window.tracking.getSearchClickResult({
        searchTerm: term,
        category: category,
        position,
        url,
        displayMode: 'grid-mode',
      });
    },
  },
};
